export default __webpack_public_path__ + "static/media/app2-22.2f85a6b7.jpg";